import FormBuilder from "../form_components/FormBuilder";
import Input from "../form_components/Input";
import SelectInput from "../form_components/SelectInput";
import Textarea from "../form_components/Textarea";

export default function BugReport() {
    return (
        <>
            <FormBuilder title='Bug report' post={'/bug'} >
                <Input width='full' label="Bug title" type='text' placeholder='Title' extraClasses='border block rounded px-2 dark:border-black' required={true} value='' onChange={(name, value) => { }} name='title' />
                <Textarea width='full' label="Bug description" placeholder='Describe the bug...' extraClasses='border block rounded px-2 mb-2 dark:bg-black dark:border-black' required={true} value='' onChange={(name, value) => { }} name='body' rows={6} />
            </FormBuilder>
        </>
    )
}